import {REGEX_COMMUNITY_REPLY} from '../../../core/entities/community/constants';

export const isReply = (body: string): boolean => {
  return REGEX_COMMUNITY_REPLY.test(body);
};
